import {useState} from 'react';

// interface IPlayPause {
// cssClass: string;
// label: string;
// isPaused: boolean;
// }

/**
 * 재생/일시정지 이벤트 hooks
 */
export default function usePlayPause(
  videoDOM: HTMLVideoElement,
): [boolean, (e?: any) => void] {
  // const [playPause, setPlayPause] = useState({
  //     cssClass: "play",
  //     label: "재생",
  // });
  const [isPaused, setPaused] = useState(true); // 초기값은 일시정지

  const setValue = (e?: any) => {
    if (e) {
      e.preventDefault();
    }
    if (videoDOM === null) {
      return;
    }

    if (videoDOM.paused) {
      // setPlayPause({
      //     cssClass: "pause",
      //     label: "일시정지",
      // });
      setPaused(false);
      videoDOM.play();
    } else {
      // setPlayPause({
      //     cssClass: "play",
      //     label: "재생",
      // });
      setPaused(true);
      videoDOM.pause();
    }
  };

  return [isPaused, setValue];
}
